import { render, staticRenderFns } from "./StudentsWithPhoto.vue?vue&type=template&id=dc446d1a&"
import script from "./StudentsWithPhoto.vue?vue&type=script&lang=js&"
export * from "./StudentsWithPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports